import { Check, Languages } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';
import { LANGUAGES, lang, setLang, t } from '@/lib/i18n';

/**
 * Nepali or English for the interface.
 *
 * Each language is labelled in its own script — नेपाली, not "Nepali" — so a
 * reader who cannot read the current interface can still find their way out of
 * it. That is the one case this control has to serve.
 */
export function LanguageToggle({ className }: { className?: string }) {
  const current = lang();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className={className} aria-label={t('भाषा')} title={t('भाषा')}>
          <Languages />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        {LANGUAGES.map((language) => (
          <DropdownMenuItem
            key={language.code}
            className="gap-2"
            onSelect={() => {
              if (language.code !== current) setLang(language.code);
            }}
          >
            <Check className={cn('size-4', language.code === current ? 'opacity-100' : 'opacity-0')} />
            <span className={cn(language.code === 'ne' && 'np')}>{language.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
